<div class="reset-screen">
  <div class="guide">
    <kp-reflect-animation [skipIntro]="true" [canvasHeight]="110"></kp-reflect-animation>
  </div>

  <div class="reset" *ngIf="showForm && !hasError">
    <h1 class="reset-title">Reset Your Password</h1>
    <p class="reset-email">
      {{ email }}
    </p>
    <p class="reset-description">
      If you have a Kumanu account with this email address, you will receive an email with a code to reset your
      password.
    </p>
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <label>
        <div class="code-heading">
          <span class="form_label">Code</span>
          <a routerLink="/login/reset/code/resend" class="resend-code">Didn't receive a code?</a>
        </div>
        <input
          type="tel"
          inputmode="number"
          maxlength="6"
          placeholder="123456"
          autocomplete="one-time-code"
          required
          [formControl]="passwordCode"
          (keydown)="handleKeydown($event)" />
      </label>
      <p class="code-error" *ngIf="showCodeError">
        <svg-icon src="/assets/icons/alert-circle.svg" class="alert-icon"></svg-icon>
        <span>{{ codeMismatchError }}</span>
      </p>
      <label>
        <span class="form_label">New Password</span>
        <div class="bottom-border password-container">
          <input
            class="input"
            placeholder="New Password"
            required
            [formControl]="newPassword"
            autocomplete="new-password"
            (change)="passwordChanged()"
            (input)="passwordChanged()"
            [type]="showPassword ? 'text' : 'password'" />
          <button class="toggle-show-password" (click)="toggleShowPassword($event)" type="button">
            <svg-icon
              [src]="
                showPassword ? '/assets/icons/icons-nav-visibility.svg' : '/assets/icons/icons-nav-visibility-off.svg'
              "></svg-icon>
          </button>
        </div>
      </label>
      <p
        class="password-error"
        *ngIf="(!newPassword.valid || showError || hasInvalidPasswordError) && displayErrorMessage">
        <svg-icon src="/assets/icons/alert-circle.svg" class="alert-icon"></svg-icon>
        <span>{{ displayErrorMessage }}</span>
      </p>
      <button [disabled]="!resetForm.valid || processing" type="submit" class="button button-pill">
        Reset Password
      </button>
    </form>
  </div>
  <div class="reset reset-success" *ngIf="!showForm && !hasError && showPasswordSuccess">
    <h1 class="reset-title">Reset Password</h1>
    <p class="reset-description">Your password has been successfully reset.</p>
    <p class="reset-description" *ngIf="!authenticationBloc.isLoggedIn()">Please click Continue to login.</p>
    <button class="button button-pill" [disabled]="processing" (click)="login()">Continue</button>
  </div>
  <div class="reset reset-error" *ngIf="!showForm && hasError && showError">
    <h1 class="reset-title">Error</h1>
    <p class="reset-description">
      There was an error trying to reset your password. Check the code to make sure it is correct. If the error
      persists, please contact
      <a
        href="mailto:support@kumanu.com?Subject={{ productName }}%20Support%20Request%20-%20Password%20Reset"
        target="_blank">
        support@kumanu.com
      </a>
      for assistance.
    </p>
    <button class="button button-pill" [disabled]="processing" (click)="resetState()">Retry</button>
  </div>
</div>
